import React from "react"
import styles from "./icon-heading.module.scss"

export default (props) => (
  <div className={styles.iconHeading} style={props.style}>
    <img className={styles.iconHeadingImage} src={props.image} alt={props.text}/>
    <h5 className={styles.iconHeadingText}>{props.text}</h5>
  </div>
)
